var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.308 170.074c-25.131 59.004-91.47 84.348-143.447 80.026-14.192-1.179-42.746-3.554-65.042-24.732C-11.998 184.697-5.404 99.682 35.585 49.63 40.863 43.184 77.399-.002 134.335.577c41.684.423 70.943 24.075 74.5 27.021 4.495 3.723 14.407 12.568 23.341 26.601 20.991 32.974 22.836 79.004 7.132 115.875z",
    fill: "url(#mtpq1n1gxa)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M238.748 206.38c0 2.437-1.825 4.431-4.056 4.431H15.418c-2.23 0-4.054-1.994-4.054-4.431L9.538 68.544c0-2.437 2.625-7.195 7.436-6.837l214.3-6.066c2.798-.079 5.504 1.1 7.485 3.26 1.982 2.16 3.067 5.115 3 8.172l-3.011 139.307z",
    fill: "url(#xvop7nf2mb)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.745 202.129c0 2.308-1.726 4.196-3.836 4.196H20.706c-2.11 0-3.837-1.888-3.837-4.196L15.148 77c.202-7.53 6.237-10.236 9.896-10.076l205.386-6.028c1.967-.057 3.867.771 5.26 2.29 1.392 1.52 2.158 3.598 2.109 5.749l-3.054 133.194z",
    fill: "#91B3FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248.609 222.253H1.379a.674.674 0 0 1-.67-.674v-10.764c0-.37.302-.674.671-.674h247.23c.37 0 .672.304.672.674v10.764a.677.677 0 0 1-.673.674z",
    fill: "url(#zj5wxd2vcc)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.575 74.345 169.864 70.9c2.378-.055 4.348 1.366 4.348 3.14v1.633c0 1.704-1.823 3.096-4.109 3.14L23.878 81.571c-2.288.043-4.204-1.282-4.317-2.985l-.063-.949c-.117-1.753 1.72-3.238 4.077-3.293z",
    fill: "#BDD0FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.843 74.796c.311-2.49-1.41-4.755-3.843-5.06-2.434-.307-4.658 1.462-4.968 3.951-.163 1.301.23 2.54.99 3.472l-4.53 3.5a.635.635 0 0 0-.064.928l.041.044a.584.584 0 0 0 .831.022l4.115-4.07a4.357 4.357 0 0 0 2.46 1.166c2.434.306 4.658-1.464 4.968-3.953zm-4.818 2.746c-1.781-.225-3.042-1.884-2.815-3.707.228-1.823 1.857-3.12 3.639-2.895 1.782.224 3.043 1.884 2.815 3.707-.227 1.824-1.856 3.12-3.639 2.895z",
    fill: "url(#crersu8ead)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m20.82 138.007 2.439 59.283c.082 1.998 2.86 3.585 6.229 3.558l71.619-.586c3.368-.028 6.07-1.658 6.062-3.655l-.249-59.839c-.009-2.048-2.857-3.69-6.307-3.636l-73.81 1.141c-3.389.052-6.067 1.722-5.984 3.734zM120.94 85.542l44.898-.549c4.595-.056 8.406 1.443 8.444 3.322l.762 37.267c.039 1.878-3.705 3.402-8.299 3.38l-46.74-.234c-2.63-.014-4.762-.876-4.824-1.95l-2.192-37.806c-.108-1.843 3.446-3.375 7.951-3.43zM32.09 84.688l63.89-.566c6.539-.057 11.961 1.488 12.016 3.424l1.085 38.407c.054 1.936-5.274 3.507-11.811 3.483l-66.513-.241c-3.742-.014-6.777-.901-6.865-2.009l-3.12-38.963c-.151-1.899 4.904-3.478 11.317-3.535zM120.834 133.531l44.897-.87c4.596-.089 8.406 2.29 8.445 5.271l.762 59.143c.038 2.98-3.705 5.399-8.3 5.362l-46.74-.372c-2.63-.021-4.762-1.389-4.824-3.094l-2.192-59.999c-.107-2.922 3.445-5.354 7.952-5.441zM186.745 69.239l35.027-.567c3.585-.058 6.557 1.49 6.588 3.432l.595 38.494c.03 1.94-2.891 3.514-6.476 3.491l-36.464-.242c-2.052-.014-3.715-.904-3.765-2.014l-1.709-39.051c-.083-1.904 2.688-3.486 6.204-3.543zM187.604 119.257l35.027-.444c3.585-.046 6.558 1.169 6.588 2.692l.595 30.203c.031 1.522-2.891 2.758-6.475 2.739l-36.465-.191c-2.052-.01-3.715-.709-3.764-1.579l-1.71-30.641c-.083-1.493 2.688-2.734 6.204-2.779z",
    fill: "#BDD0FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "m189.277 161.193 35.027-.512c3.585-.052 6.557 1.347 6.588 3.1l.595 34.768c.03 1.752-2.891 3.174-6.475 3.153l-36.465-.219c-2.052-.013-3.715-.816-3.764-1.819l-1.71-35.271c-.084-1.719 2.687-3.149 6.204-3.2z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.809 25.787c.042-.095.084-.191.128-.286 2.153-4.563 5.717-5.508 8.858-4.012 3.141 1.495 4.67 4.863 2.517 9.427-.019.04-.04.079-.058.118-2.118-1.593-6.184-4.17-11.445-5.247z",
    fill: "url(#uerv5snm3e)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.254 31.034c-2.184 4.514-7.142 8.462-10.256 6.98-3.076-1.464-3.207-7.685-1.189-12.228 5.261 1.08 9.327 3.655 11.445 5.248z",
    fill: "url(#y2vc1ey47f)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M199.767 23.354c1.069-1.935 2.007-3.935 2.754-6.023.362-1.048.681-2.117.853-3.23a8.34 8.34 0 0 0 .1-1.697c-.024-.573-.154-1.168-.458-1.7a2.538 2.538 0 0 0-1.403-1.133c-.578-.201-1.16-.233-1.743-.193-.58.04-1.209.212-1.693.654-.497.434-.706 1.097-.741 1.697-.039.61.085 1.2.285 1.754.206.553.482 1.082.928 1.533.228.215.497.443.914.504.207.025.438-.018.62-.125.19-.105.306-.248.422-.39.369-.585.453-1.17.54-1.742a.393.393 0 1 0-.775-.119l-.001.012-.002.019c-.061.51-.163 1.043-.382 1.397-.122.164-.214.22-.338.21-.134-.01-.328-.132-.491-.29-.337-.324-.599-.783-.781-1.255-.181-.473-.294-.983-.269-1.473.023-.485.17-.956.509-1.258.328-.312.807-.47 1.309-.513 1.017-.104 2.118.14 2.614 1 .25.417.38.926.411 1.448a7.878 7.878 0 0 1-.068 1.59c-.145 1.067-.439 2.121-.777 3.157-.699 2.066-1.6 4.076-2.623 6.005l-.002.005a.165.165 0 0 0 .067.223.165.165 0 0 0 .221-.067z",
    fill: "url(#sklpwxdhmg)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M203.25 24.987c.839-2.017 1.818-3.99 2.968-5.842.584-.919 1.21-1.814 1.94-2.603a7.88 7.88 0 0 1 1.182-1.06c.422-.308.897-.528 1.377-.598.976-.16 1.861.543 2.424 1.399.284.417.468.89.434 1.343-.017.455-.288.868-.647 1.193-.361.33-.827.564-1.306.723-.479.157-.998.244-1.461.188-.225-.027-.442-.1-.535-.2-.085-.088-.1-.195-.052-.394.135-.395.48-.813.835-1.183l.012-.012a.395.395 0 0 0-.01-.557.391.391 0 0 0-.554.01l-.009.01c-.385.43-.782.866-.999 1.522-.038.18-.073.36-.035.576.032.208.147.416.297.561.31.285.657.35.967.39.629.062 1.212-.058 1.768-.247.553-.196 1.086-.473 1.533-.89.44-.406.818-.99.837-1.65.034-.656-.232-1.254-.567-1.73-.339-.478-.732-.912-1.253-1.232a2.539 2.539 0 0 0-1.761-.374c-.602.1-1.144.376-1.6.72a8.268 8.268 0 0 0-1.245 1.153c-.749.838-1.37 1.763-1.948 2.707-1.137 1.902-2.083 3.899-2.897 5.954a.164.164 0 0 0 .304.125l.001-.002z",
    fill: "url(#s0qkhzjduh)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M200.587 27.144s-1.842 16.688 4.66 17.606c6.501.918 5.996-8.657-4.66-17.606zM200.586 27.144s-11.694 11.998-16.518 7.524c-4.824-4.473 2.874-10.143 16.518-7.524z",
    fill: "#91B3FA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M199.595 27.744s-15.712 5.733-18.134-.396c-2.421-6.13 6.961-7.895 18.134.396zM201.223 28.519s5.529 15.845 11.786 13.847c6.257-1.997 1.677-10.41-11.786-13.847z",
    fill: "#91B3FA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M205.157 43.7a.385.385 0 0 0 .167.037c1.481.004 2.483-.465 2.977-1.393 1.451-2.727-2.362-8.487-2.525-8.732a.39.39 0 0 0-.543-.107.395.395 0 0 0-.107.546c1.037 1.552 3.506 6.003 2.484 7.922-.347.651-1.115.98-2.284.978a.391.391 0 0 0-.392.392.392.392 0 0 0 .223.356z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.276 27.8s-5.547-8.641-8.805-10.19c-3.511-1.671-8.865-.113-11.494.848-.514.187-.484.922.041 1.077 6.006 1.77 12.953 4.782 20.258 8.265z",
    fill: "url(#fzci3la75i)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M199.709 27.53s10.171-1.158 13.428.393c3.51 1.672 5.699 6.821 6.624 9.474.18.517-.405.96-.856.65-5.168-3.548-11.888-7.043-19.196-10.517z",
    fill: "url(#fe6kmw7exj)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M217.659 35.573a.387.387 0 0 0 .326.004.395.395 0 0 0 .201-.518c-.142-.32-3.512-7.843-9.117-7.332a.392.392 0 0 0-.354.427c.019.216.21.376.425.356 5.049-.46 8.296 6.793 8.328 6.866.04.09.109.157.191.197z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m176.885 205.375-1.6-102.503c-.017-1.125 1.063-2.044 2.401-2.044 2.164 0 3.918-1.475 3.918-3.294V72.496c0-1.594 1.571-2.87 3.466-2.818l8.631.24c2.124.06 3.822 1.507 3.861 3.294l2.952 132.164h-23.629v-.001z",
    fill: "url(#grpt5jvtrk)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m200.822 153.806.036 1.122c3.434 4.802 6.558 3.577 8.71 2.136-1.295-3.234-1.525-3.591-2.558-4.716-3.884 2.837-6.188 1.458-6.188 1.458z",
    fill: "url(#tsxtpc93dl)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m216.472 148.536-6.044-9.491c-.397 5.354-1.341 10.368-3.419 13.304 1.033 1.123 1.263 1.482 2.557 4.716 5.37-3.596 6.906-8.529 6.906-8.529z",
    fill: "#4042E2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M222.406 228.187c-3.013.139-5.929.052-7.877-.048 1.773-1.268 5.858-4.026 9.276-5.124l2.346-.141s.796 1.215 1.079 3.994c-.389.487-1.526 1.167-4.824 1.319z",
    fill: "url(#wkud142c4m)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m214.505 228.156.024-.017c1.947.1 4.864.187 7.877.048 3.298-.152 4.435-.832 4.824-1.319.013.128.026.255.037.389a1.1 1.1 0 0 1-1.01 1.191c-2.467.188-8.586.613-11.536.456-.39-.018-.533-.521-.216-.748z",
    fill: "url(#hojbwgth9n)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M243.956 227.378c.22-1.421.574-3.475.848-4 .429-.824 1.897 0 1.897 0s1.03.483 1.505 1.287c.302.513 1.138 1.972 1.705 2.963a.662.662 0 0 1 .088.353l-5.878.207a1.183 1.183 0 0 1-.165-.81z",
    fill: "url(#8n9jprxnco)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M249.999 227.981a.67.67 0 0 1-.651.653l-4.189.116a1.18 1.18 0 0 1-1.039-.563l5.879-.206z",
    fill: "url(#ap5ezu0pbp)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M243.506 218.655c.051.171.81 3.87 1.143 5.493a.924.924 0 0 0 .95.741c.248-.013.538-.035.842-.075.538-.07.948-.521.969-1.066.054-1.422.081-4.153-.439-5.211-.718-1.459-3.465.118-3.465.118z",
    fill: "url(#g2mi712asq)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M226.613 219.715c-.326-.011.13 1.689-.363 3.361-.111.377-.391.672-.783.677a8.937 8.937 0 0 1-.858-.026.946.946 0 0 1-.871-.855l-.401-4.334 3.276 1.177z",
    fill: "url(#te2isqaecr)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M217.498 173.64c.146.711 5.278 30.784 5.59 46.346a.53.53 0 0 0 .454.516c.651.091 1.92.208 3.151-.021a.37.37 0 0 0 .306-.343c.18-2.9 1.622-27.418-.144-38.96 0 0 14.594 30.854 16.807 39.361a.443.443 0 0 0 .455.334c.625-.033 1.925-.146 2.958-.527a.777.777 0 0 0 .487-.912c-1.236-5.092-9.899-40.17-15.78-47.899l-14.284 2.105z",
    fill: "url(#70bt5dwa5s)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M226.854 181.369a.193.193 0 0 0 .134-.054.193.193 0 0 0 .003-.272l-1.955-2.008a.19.19 0 0 0-.27-.002.193.193 0 0 0-.003.272l1.954 2.007a.194.194 0 0 0 .137.057z",
    fill: "url(#ucmprtgowt)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M209.157 135.989c3.749-.987 10.665-2.547 16.169-2.201 1.798.113 2.138 1.813 2.21 3.083.832 14.727 2.107 27.061 4.247 34.665-4.81 1.912-9.579 2.799-14.283 2.104-3.525-7.583-6.606-16.337-9.239-26.279 0 0-1.544-7.929-.044-10.572.233-.411.54-.695.94-.8z",
    fill: "#4042E2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M218.173 125.674s.946 5.673 1.229 8.296a1.03 1.03 0 0 1-.556 1.026c-1.035.535-3.243 1.397-5.65.606a.957.957 0 0 1-.647-.935l.165-7.573 5.459-1.42z",
    fill: "#4042E2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M195.41 95.764a.282.282 0 0 0 .106-.382l-.384-.684-.03.017-2.261-3.685a.279.279 0 0 0-.384-.092l-.428.266a.281.281 0 0 0-.091.385l2.088 3.401a.282.282 0 0 1-.1.391l-16.408 9.295a.281.281 0 0 0-.106.381l.384.684.005-.003 5.332 9.498a.279.279 0 0 0 .38.106l.437-.248a.282.282 0 0 0 .107-.382l-5.195-9.253a.28.28 0 0 1 .106-.381l16.442-9.314z",
    fill: "url(#32vza1ss0u)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m188.701 83.012-34.005 19.262 4.361 7.768 34.005-19.263-4.361-7.767z",
    fill: "#7D97F4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m218.378 181.112-2.516 1.279a.133.133 0 0 1-.18-.059l-34.126-67.714a.134.134 0 0 1 .059-.18l2.516-1.28a.134.134 0 0 1 .18.06l34.126 67.714a.133.133 0 0 1-.059.18z",
    fill: "url(#n9y4j76uvv)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M159.058 110.042c.799-.452.462-2.571-.751-4.732-1.214-2.161-2.845-3.547-3.643-3.095-.798.453-.462 2.571.752 4.732 1.213 2.162 2.844 3.547 3.642 3.095zM192.839 90.943c.799-.452.462-2.57-.751-4.732-1.213-2.161-2.844-3.546-3.643-3.094-.798.452-.461 2.57.752 4.732 1.213 2.16 2.844 3.546 3.642 3.094z",
    fill: "#7D97F4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M200.272 153.979a1.445 1.445 0 0 1-.17-1.224c.246-.803.763-1.982 1.626-1.722 1.285.389 1.457 3.578 1.457 3.578l-.341 2.048.428 1.021c-.848-.412-1.893-1.887-3-3.701z",
    fill: "url(#lruo0ff0tw)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M230.024 161.186c.525-.74 1.052-1.55 1.572-2.444 5.142-8.847-4.289-22.394-4.289-22.394l-2.874 8.594c4.249 4.76 2.465 9.353 1.019 13.164-1.893 4.989-10.079 9.219-10.079 9.219l1.559 1.933c0-.001 8.415-1.489 13.092-8.072z",
    fill: "url(#c91dcxresx)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M233.256 149.854c-.107-6.867-5.537-14.163-6.529-15.448a.152.152 0 0 0-.259.032l-2.035 10.504c.864 2.029.689 3.307 1.552 5.135 2.336-.328 4.504-.345 6.808.156a.38.38 0 0 0 .463-.379z",
    fill: "#4042E2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M215.371 167.324c-.478-.242-4.225.305-3.651.823 1.007.908 1.051 1.596-.008 2.445-.523.419-1.724 1.055-2.052.076-.092-.276-.104-.632-.365-.758-.193-.092-.738.57-.77.783-.183 1.192.765 2.183 1.809 2.578.507.192 1.047.274 1.582.355.298.045 1.04.156 1.107.126.078-.034.124-.113.181-.176.244-.272 1.55-1.377 1.835-1.747.154-.2 2.112-2.68 2.013-2.917-.001-.001-1.275-1.382-1.681-1.588z",
    fill: "url(#ybnw1sjzry)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M211.619 119.629s-3.027 5.724-2.639 8.036c.387 2.312 4.139 2.146 7.415.269l2.29-6.181-7.066-2.124z",
    fill: "url(#0agd09oocz)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M216.251 124.899a.238.238 0 0 1-.103-.346c.242-.372.697-1.131.842-1.796 0 0 .544-.35-1.385-.814-1.93-.464-4.806-1.184-5.411-2.833-.59-1.609.959-5.653 3.43-2.43a.234.234 0 0 0 .372.003c.405-.53 1.47-1.63 2.949-.963 1.385.624 1.54 1.643 1.521 2.156a.235.235 0 0 0 .277.241c.7-.134 2.379-.25 3.163 1.481.645 1.426.226 2.232-.156 2.627a.235.235 0 0 0 .1.39c.46.142 1.053.533.994 1.615-.082 1.496-1.747 1.364-2.221 1.296a.233.233 0 0 0-.209.074c-.406.451-2.237 2.37-4.22 2.602a.238.238 0 0 1-.249-.314l.858-2.505a.236.236 0 0 0-.128-.294l-.424-.19z",
    fill: "url(#7no33qbarA)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M215.906 125.254s2.155-1.485 2.313-.234c.157 1.251-1.941 1.811-2.981 1.345l.668-1.111z",
    fill: "url(#0sz3zqwihB)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M209.432 228.388c-6.621 2.22-13.052 2.223-19.255.194a3.827 3.827 0 0 1-2.63-3.638V194.43c7.622 1.685 15.611 1.77 24.027 0v30.986a3.135 3.135 0 0 1-2.142 2.972z",
    fill: "#BDD0FB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M199.561 196.611c6.635 0 12.014-1.086 12.014-2.425 0-1.34-5.379-2.426-12.014-2.426s-12.013 1.086-12.013 2.426c0 1.339 5.378 2.425 12.013 2.425z",
    fill: "#7D97F4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M211.575 217.924c-8.009 2.798-16.018 2.798-24.027 0v-12.173c8.081 2.001 16.094 2.104 24.027 0v12.173z",
    fill: "url(#pjqwxcd3nC)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M188.836 197.203c.258.965 1.355 1.617 2.322 1.378.677-.167 1.257-.701 1.955-.712.793-.014 1.426.642 1.888 1.29a12.798 12.798 0 0 1 1.879 3.884c.134.462.252.954.576 1.309.692.762 2.001.518 2.771-.165.769-.682 1.187-1.668 1.759-2.524.572-.856 1.451-1.655 2.475-1.593.343.02.676.139 1.019.153.76.033 1.507-.509 1.718-1.243.065-.225.085-.468.2-.671.347-.61 1.266-.669 1.74-1.164.301-.313.402-.769.753-1.078.133-.117 1.044-.495 1.062-.553.16-.492-.348-.936-.819-1.147-2.762-1.235-5.92-.004-8.914.417-2.942.414-5.757-.26-8.671-.235-1.606.016-4.312.404-3.713 2.654z",
    fill: "url(#i4zj4lnpyD)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M199.7 196.68c6.635 0 12.013-1.086 12.013-2.425 0-1.34-5.378-2.426-12.013-2.426s-12.013 1.086-12.013 2.426c0 1.339 5.378 2.425 12.013 2.425z",
    fill: "#7D97F4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M199.38 195.721c5.463 0 9.89-.657 9.89-1.467s-4.427-1.466-9.89-1.466c-5.462 0-9.89.656-9.89 1.466 0 .81 4.428 1.467 9.89 1.467z",
    fill: "url(#jseehawu7E)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M68.694 226.003H3.75A3.759 3.759 0 0 1 0 222.236v-62.987a3.758 3.758 0 0 1 3.74-3.766l65.464-.177a3.757 3.757 0 0 1 3.76 3.786l-.52 63.163a3.76 3.76 0 0 1-3.75 3.748z",
    fill: "#7D97F4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m65.512 160.128-58.07.359a3.813 3.813 0 0 0-3.782 3.839l.405 52.976a3.813 3.813 0 0 0 3.736 3.803l56.422 1.034a3.812 3.812 0 0 0 3.874-3.767l1.243-54.369a3.813 3.813 0 0 0-3.828-3.875z",
    fill: "#BDD0FB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M63.15 165.041v.402a1.14 1.14 0 0 1-1.138 1.143H17.27a1.14 1.14 0 0 1-1.138-1.143v-.402c0-.631.51-1.144 1.138-1.144h44.743c.63 0 1.139.513 1.139 1.144zM58.159 170.099a1.142 1.142 0 0 1-1.116 1.082l-39.13.716a1.142 1.142 0 0 1-1.16-1.143v-.093c0-.625.5-1.134 1.12-1.144l39.13-.623a1.14 1.14 0 0 1 1.156 1.205z",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M62.152 219.143h-.04l-52.925-.638a3.215 3.215 0 0 1-2.29-.99 3.246 3.246 0 0 1-.914-2.33l1.362-37.408a3.246 3.246 0 0 1 3.306-3.185l52.833 1.033a3.257 3.257 0 0 1 3.18 3.315v.009l-1.27 37.005a3.253 3.253 0 0 1-3.242 3.189zm-51.565-43.468c-.562 0-1.093.215-1.5.608a2.164 2.164 0 0 0-.663 1.525l-1.361 37.409c-.011.573.205 1.125.609 1.545.405.419.947.653 1.528.66l52.925.638h.026a2.174 2.174 0 0 0 2.164-2.134l1.27-37.009a2.174 2.174 0 0 0-2.122-2.208l-52.833-1.033-.043-.001z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M65.44 182.891H7.8a.54.54 0 0 1 0-1.084h57.64a.54.54 0 0 1 0 1.084z",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M44.188 51.68a.366.366 0 0 1-.61-.241 41.324 41.324 0 0 1-.101-1.483.367.367 0 1 1 .733-.036c.023.482.056.972.098 1.454a.374.374 0 0 1-.12.305z",
    fill: "url(#0faus1243F)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M105.561 17.284a.367.367 0 0 1-.465.022 37.474 37.474 0 0 0-2.462-1.694.37.37 0 0 1-.115-.508.363.363 0 0 1 .505-.116c.855.54 1.7 1.121 2.51 1.727a.369.369 0 0 1 .027.57zm-6.787-4.055a.365.365 0 0 1-.4.06 38.07 38.07 0 0 0-2.756-1.15.368.368 0 0 1 .255-.69c.95.353 1.895.748 2.81 1.173a.369.369 0 0 1 .09.607zm-7.47-2.579a.364.364 0 0 1-.33.086 38.608 38.608 0 0 0-2.93-.57.367.367 0 0 1-.306-.42c.03-.2.217-.339.417-.307.997.153 2.001.348 2.987.58a.369.369 0 0 1 .162.631zm-47.14 34.645a.367.367 0 0 1-.611-.303c.08-1.01.2-2.03.36-3.033a.367.367 0 1 1 .724.115 38.856 38.856 0 0 0-.353 2.977.372.372 0 0 1-.12.244zM83.471 9.643a.363.363 0 0 1-.255.095 37.956 37.956 0 0 0-2.981.044.367.367 0 0 1-.386-.347.367.367 0 0 1 .346-.388 38.136 38.136 0 0 1 3.039-.046.368.368 0 0 1 .237.642zM45.593 37.492a.366.366 0 0 1-.598-.376c.284-.977.608-1.952.964-2.899a.365.365 0 0 1 .471-.214c.19.072.285.283.214.474a39.25 39.25 0 0 0-.945 2.844.358.358 0 0 1-.106.17zm30.01-27.221a.37.37 0 0 1-.18.089c-.97.18-1.95.4-2.91.658a.368.368 0 0 1-.188-.712 38.784 38.784 0 0 1 2.965-.672c.2-.036.39.095.427.296a.372.372 0 0 1-.115.34zm-27.04 19.87a.366.366 0 0 1-.418.052.37.37 0 0 1-.152-.498c.475-.896.99-1.785 1.533-2.64a.366.366 0 0 1 .506-.113c.17.11.22.337.113.508-.532.84-1.038 1.71-1.504 2.59a.37.37 0 0 1-.078.101zm19.463-17.639a.346.346 0 0 1-.108.068 38.52 38.52 0 0 0-2.716 1.24.368.368 0 0 1-.329-.657 38.453 38.453 0 0 1 2.768-1.264.366.366 0 0 1 .385.613zm-6.968 3.732a.35.35 0 0 1-.041.032 38.112 38.112 0 0 0-2.41 1.769.365.365 0 0 1-.515-.06.376.376 0 0 1 .06-.518 39.133 39.133 0 0 1 2.456-1.802.366.366 0 0 1 .509.1.37.37 0 0 1-.06.479zm-8.09 7.323a.365.365 0 0 1-.48.009.37.37 0 0 1-.046-.519 38.81 38.81 0 0 1 2.04-2.268.368.368 0 0 1 .524.515 38.233 38.233 0 0 0-2 2.224.495.495 0 0 1-.038.039z",
    fill: "url(#80kjjyuosG)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M110.339 21.52a.366.366 0 0 1-.511-.019 38.77 38.77 0 0 0-1.024-1.032.37.37 0 0 1-.009-.52.372.372 0 0 1 .519-.01c.353.343.705.697 1.043 1.052a.37.37 0 0 1-.01.52l-.008.009z",
    fill: "url(#36upx3dkxH)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M121.059 49.712a.365.365 0 0 1-.612-.286c.017-.487.025-.978.025-1.458 0-.203.163-.368.365-.369.203 0 .367.164.367.368.001.49-.008.99-.026 1.487a.36.36 0 0 1-.119.258z",
    fill: "url(#67orz2kkhI)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m108.392 77.025-.247.222a.367.367 0 0 1-.489-.548l.002-.003.243-.217a38.97 38.97 0 0 0 1.878-1.823.369.369 0 0 1 .518-.01c.146.142.15.375.009.522a39.476 39.476 0 0 1-1.914 1.857zm-4.039 3.197c-.013.011-.025.022-.039.03a39.512 39.512 0 0 1-2.531 1.604.366.366 0 0 1-.501-.135.37.37 0 0 1 .134-.503c.845-.49 1.681-1.02 2.485-1.573a.365.365 0 0 1 .509.095.372.372 0 0 1-.057.482zm9.057-8.72a.366.366 0 0 1-.465.021.37.37 0 0 1-.074-.515 38.007 38.007 0 0 0 1.668-2.428.365.365 0 0 1 .506-.114.37.37 0 0 1 .113.508 39.485 39.485 0 0 1-1.699 2.475.367.367 0 0 1-.049.052zM97.534 83.966a.358.358 0 0 1-.103.066c-.916.39-1.858.747-2.799 1.063a.367.367 0 0 1-.232-.698c.922-.31 1.847-.661 2.747-1.044a.366.366 0 0 1 .48.196.372.372 0 0 1-.093.417zm19.877-19.158a.366.366 0 0 1-.577-.43c.413-.882.798-1.796 1.144-2.716a.366.366 0 0 1 .473-.213c.19.072.284.284.213.474a39.403 39.403 0 0 1-1.167 2.769.39.39 0 0 1-.086.116zM90.109 86.267a.362.362 0 0 1-.174.087c-.973.196-1.966.356-2.953.477a.368.368 0 0 1-.088-.732 38.423 38.423 0 0 0 2.899-.468.366.366 0 0 1 .431.289.375.375 0 0 1-.115.347zm29.882-28.823a.364.364 0 0 1-.333.084.368.368 0 0 1-.269-.444c.23-.953.427-1.925.584-2.892a.366.366 0 1 1 .723.12 39.973 39.973 0 0 1-.596 2.946.355.355 0 0 1-.109.185zM82.376 87.016a.361.361 0 0 1-.248.095 38.7 38.7 0 0 1-2.989-.133.369.369 0 0 1 .06-.734 38.2 38.2 0 0 0 2.934.13.367.367 0 0 1 .243.642zm-7.725-.833a.365.365 0 0 1-.322.088 39.656 39.656 0 0 1-2.903-.732.369.369 0 0 1 .205-.707 38.937 38.937 0 0 0 2.849.718.369.369 0 0 1 .171.633zm-7.407-2.363a.366.366 0 0 1-.392.065 39.055 39.055 0 0 1-2.7-1.298.369.369 0 0 1 .343-.652c.862.457 1.754.885 2.649 1.274a.368.368 0 0 1 .1.611zm-6.786-3.807a.365.365 0 0 1-.456.028 39.242 39.242 0 0 1-2.383-1.82.369.369 0 0 1-.05-.518.368.368 0 0 1 .516-.05c.753.623 1.54 1.224 2.337 1.785a.37.37 0 0 1 .036.575z",
    fill: "url(#bca9a8vdeJ)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M54.568 74.897a.366.366 0 0 1-.512-.02c-.335-.356-.67-.727-.994-1.1-.134-.153-.101-.386.034-.52a.365.365 0 0 1 .518.036c.319.366.647.73.976 1.08a.369.369 0 0 1-.022.524z",
    fill: "url(#3l5whc3g4K)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M57.777 64.651a.464.464 0 0 0 .48.243l5.56-.866a24.513 24.513 0 0 0 6.11 5.093l.181 5.644c.007.198.137.37.326.428l6.448 2a.461.461 0 0 0 .509-.17l3.32-4.557a24.4 24.4 0 0 0 7.905-.744l4.106 3.864a.46.46 0 0 0 .531.071l5.967-3.165a.467.467 0 0 0 .242-.482l-.862-5.584a24.586 24.586 0 0 0 5.07-6.137l5.619-.183a.46.46 0 0 0 .426-.327l1.992-6.477a.466.466 0 0 0-.169-.511l-4.537-3.335a24.734 24.734 0 0 0-.741-7.94l3.847-4.124a.465.465 0 0 0 .071-.535l-3.151-5.993a.464.464 0 0 0-.48-.242l-5.559.865a24.513 24.513 0 0 0-6.11-5.093l-.182-5.644a.463.463 0 0 0-.325-.428l-6.448-2a.461.461 0 0 0-.51.17l-3.32 4.557a24.398 24.398 0 0 0-7.905.744l-4.105-3.863a.46.46 0 0 0-.531-.072l-5.967 3.165a.466.466 0 0 0-.241.482l.861 5.584a24.57 24.57 0 0 0-5.07 6.137l-5.619.184a.462.462 0 0 0-.426.326l-1.991 6.477c-.058.19.01.395.169.511l4.537 3.335c-.188 2.71.077 5.387.74 7.94L54.7 58.125a.466.466 0 0 0-.071.534l3.149 5.993z",
    fill: "url(#8im3agfyoL)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M86.785 52.637a6.48 6.48 0 0 1-4.724 1.683 6.488 6.488 0 0 1-4.52-2.164 6.545 6.545 0 0 1-1.671-4.74c.188-3.619 3.272-6.409 6.874-6.218 1.746.091 3.35.86 4.52 2.164a6.546 6.546 0 0 1 1.672 4.74 6.55 6.55 0 0 1-2.151 4.535zM78.757 43.7a5.441 5.441 0 0 0-1.79 3.773 5.44 5.44 0 0 0 1.391 3.944 5.396 5.396 0 0 0 3.76 1.8 5.393 5.393 0 0 0 3.926-1.397l.003-.003a5.442 5.442 0 0 0 1.79-3.773 5.442 5.442 0 0 0-1.391-3.943 5.395 5.395 0 0 0-3.76-1.8 5.392 5.392 0 0 0-3.926 1.396c0 .002-.002.003-.003.003z",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M93.816 60.213c-4.262 3.863-10.387 5.444-16.26 3.623a16.942 16.942 0 0 1-3.294-1.42l.54-.962c.97.548 2.005.994 3.078 1.327 6.512 2.02 13.356-.435 17.231-5.62l.022-.028a15.754 15.754 0 0 0 2.422-4.787 15.76 15.76 0 0 0-1.12-12.043 15.906 15.906 0 0 0-2.247-3.234 15.632 15.632 0 0 0-7.022-4.487c-8.289-2.572-17.115 2.11-19.675 10.435a15.847 15.847 0 0 0-.254 8.414l-1.068.263c-.723-2.96-.629-6.074.271-9.003 2.74-8.906 12.183-13.916 21.05-11.164a16.71 16.71 0 0 1 7.513 4.8 17.013 17.013 0 0 1 2.404 3.46 16.865 16.865 0 0 1 1.199 12.885 16.815 16.815 0 0 1-4.79 7.54z",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M119.911 58.422a.287.287 0 0 1 .07-.507c.364-.124.737-.236 1.108-.336a.286.286 0 0 1 .146.553c-.359.096-.719.206-1.072.325a.286.286 0 0 1-.252-.035z",
    fill: "url(#h39mjaw0qM)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M142.631 80.319a.29.29 0 0 1-.114-.316c.218-.752.386-1.525.502-2.3a.284.284 0 1 1 .563.083c-.119.801-.293 1.6-.519 2.376a.284.284 0 0 1-.432.157zm.665-6.221a.284.284 0 0 1-.124-.217 17.736 17.736 0 0 0-.316-2.334.287.287 0 0 1 .222-.338.286.286 0 0 1 .336.223c.161.79.27 1.601.325 2.41a.286.286 0 0 1-.265.305.28.28 0 0 1-.178-.049zm-18.47-16.59a.286.286 0 0 1 .148-.522 18.405 18.405 0 0 1 2.421.06.285.285 0 0 1 .257.312.285.285 0 0 1-.309.258 17.45 17.45 0 0 0-2.346-.058.284.284 0 0 1-.171-.05zm16.961 10.522a.28.28 0 0 1-.099-.12 17.602 17.602 0 0 0-1.102-2.078.285.285 0 1 1 .484-.302c.425.688.808 1.41 1.137 2.146a.286.286 0 0 1-.42.354zM131 58.338a.286.286 0 0 1 .247-.509c.766.246 1.524.548 2.252.896a.285.285 0 0 1-.245.517 17.246 17.246 0 0 0-2.181-.867.284.284 0 0 1-.073-.037zm7.281 4.523a.231.231 0 0 1-.044-.037 17.562 17.562 0 0 0-1.747-1.57.288.288 0 0 1-.05-.403.29.29 0 0 1 .4-.049 18.26 18.26 0 0 1 1.804 1.622.288.288 0 0 1-.004.405.283.283 0 0 1-.359.032z",
    fill: "url(#okkf6itdeN)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M140.561 84.905a.287.287 0 0 1-.08-.39c.201-.316.394-.641.572-.968a.284.284 0 0 1 .387-.112.28.28 0 0 1 .112.389c-.185.337-.383.673-.591.999a.284.284 0 0 1-.393.087l-.007-.005z",
    fill: "#C9D8FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M128.698 92.884a.286.286 0 0 1-.119-.187.286.286 0 0 1 .23-.331c.367-.065.736-.143 1.097-.232a.286.286 0 0 1 .135.556c-.373.091-.754.172-1.133.24a.288.288 0 0 1-.21-.046zM116.801 90.827a.287.287 0 0 1-.087-.378.285.285 0 0 1 .389-.107c.666.382 1.364.722 2.075 1.012a.286.286 0 0 1-.214.53 18.03 18.03 0 0 1-2.163-1.057zm-3.084-2.238a.255.255 0 0 1-.031-.024 18.432 18.432 0 0 1-1.662-1.713.287.287 0 0 1 .032-.403.284.284 0 0 1 .401.032 17.62 17.62 0 0 0 1.61 1.658.287.287 0 0 1 .022.404.283.283 0 0 1-.372.046zm8.853 4.312a.287.287 0 0 1-.12-.284.284.284 0 0 1 .329-.234c.754.13 1.526.21 2.294.24.158.005.28.138.274.297a.285.285 0 0 1-.296.275 18.15 18.15 0 0 1-2.369-.247.296.296 0 0 1-.112-.047zm-12.638-9.152a.29.29 0 0 1-.09-.1 18.25 18.25 0 0 1-.986-2.178.287.287 0 0 1 .166-.37.284.284 0 0 1 .367.168c.27.72.591 1.429.954 2.108a.287.287 0 0 1-.116.388.283.283 0 0 1-.295-.016zm-1.919-5.844a.289.289 0 0 1-.121-.195 18.235 18.235 0 0 1-.186-2.385.286.286 0 1 1 .57-.007c.01.773.07 1.55.18 2.31a.286.286 0 0 1-.443.277zm.174-6.152a.288.288 0 0 1-.119-.294c.158-.78.369-1.557.628-2.308a.286.286 0 0 1 .539.187c-.251.727-.456 1.48-.608 2.235a.285.285 0 0 1-.44.18z",
    fill: "#91B3FA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M110.438 66.014a.288.288 0 0 1-.083-.386c.202-.33.416-.655.637-.97a.284.284 0 0 1 .393-.072l.004.002c.128.091.159.27.068.399-.214.305-.421.621-.616.94a.284.284 0 0 1-.392.094l-.011-.007z",
    fill: "url(#qv3fifnjwO)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M115.67 65.854a.215.215 0 0 0-.056.243l.991 2.407c-.7.993-1.248 2.104-1.606 3.303l-2.497.697a.213.213 0 0 0-.155.193l-.19 3.118a.213.213 0 0 0 .131.211l2.394.998a11.374 11.374 0 0 0 1.192 3.475l-1.276 2.268a.214.214 0 0 0 .026.246l2.061 2.34c.06.069.157.091.241.056l2.397-.995a11.274 11.274 0 0 0 3.289 1.613l.693 2.508c.024.088.102.15.192.156l3.105.191a.214.214 0 0 0 .21-.132l.993-2.404c1.228-.21 2.394-.62 3.46-1.198l2.257 1.282c.08.045.178.034.246-.026l2.33-2.07a.214.214 0 0 0 .055-.242l-.991-2.408a11.353 11.353 0 0 0 1.606-3.303l2.497-.697a.213.213 0 0 0 .155-.193l.191-3.118a.216.216 0 0 0-.132-.211l-2.393-.996a11.348 11.348 0 0 0-1.192-3.475l1.276-2.268a.214.214 0 0 0-.026-.247l-2.061-2.34a.212.212 0 0 0-.241-.055l-2.397.995a11.247 11.247 0 0 0-3.288-1.613l-.694-2.508a.213.213 0 0 0-.192-.156l-3.105-.192a.214.214 0 0 0-.21.133l-.992 2.404c-1.229.21-2.394.62-3.461 1.198l-2.257-1.282a.213.213 0 0 0-.246.026l-2.33 2.068z",
    fill: "url(#y8rmy50p2P)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "m124.087 77.742-.003-.002a3.182 3.182 0 0 1-1.335-2.053 3.198 3.198 0 0 1 .501-2.4 3.165 3.165 0 0 1 2.043-1.34 3.193 3.193 0 0 1 3.724 2.555 3.193 3.193 0 0 1-.5 2.4 3.17 3.17 0 0 1-2.044 1.34 3.15 3.15 0 0 1-2.386-.5zm3.112-4.584a2.32 2.32 0 0 0-1.747-.368 2.32 2.32 0 0 0-1.496.982 2.33 2.33 0 0 0-.367 1.757 2.33 2.33 0 0 0 .978 1.502l.002.001a2.309 2.309 0 0 0 1.747.368 2.316 2.316 0 0 0 1.496-.983 2.334 2.334 0 0 0 .366-1.756 2.34 2.34 0 0 0-.979-1.503z",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M121.474 81.73a7.982 7.982 0 0 1-3.18-8.75l.822.232a7.205 7.205 0 0 0-.161 3.138l.001.004.001.008a7.128 7.128 0 0 0 4.168 5.306 6.986 6.986 0 0 0 1.79.51l.061.008.049.006.127.016a7.012 7.012 0 0 0 5.47-1.741 7.085 7.085 0 0 0 2.375-4.891 7.086 7.086 0 0 0-1.763-5.147 7.017 7.017 0 0 0-4.87-2.386 7.042 7.042 0 0 0-3.689.782l-.393-.762a7.886 7.886 0 0 1 4.135-.877 7.868 7.868 0 0 1 5.457 2.674 7.94 7.94 0 0 1 1.976 5.766 7.948 7.948 0 0 1-2.663 5.481 7.858 7.858 0 0 1-5.74 1.985 7.84 7.84 0 0 1-3.973-1.362z",
    fill: "#fff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M165.583 32.689a.28.28 0 0 1-.133-.226c-.017-.37-.043-.741-.075-1.103a.279.279 0 1 1 .554-.05c.033.37.059.749.077 1.126a.28.28 0 0 1-.423.253zM125.073 56.77a27.163 27.163 0 0 1-1.629-1.085.28.28 0 0 1-.064-.39.275.275 0 0 1 .388-.063c.605.436 1.239.85 1.882 1.236a.282.282 0 0 1 .097.383.278.278 0 0 1-.382.097l-.292-.178zm3.586 1.842a.279.279 0 0 1 .253-.496 26.9 26.9 0 0 0 2.109.784.28.28 0 0 1-.171.532 27.338 27.338 0 0 1-2.153-.8.486.486 0 0 1-.038-.02zm5.713 1.685a.279.279 0 0 1 .194-.513c.736.13 1.486.23 2.228.298.153.013.266.15.252.303a.278.278 0 0 1-.302.253 27.06 27.06 0 0 1-2.275-.304.277.277 0 0 1-.097-.037zm5.94.376a.279.279 0 0 1 .132-.517 25.982 25.982 0 0 0 2.237-.209.28.28 0 0 1 .076.554c-.756.104-1.525.176-2.285.214a.291.291 0 0 1-.16-.042zm5.872-.967a.28.28 0 0 1 .069-.507c.718-.203 1.436-.441 2.135-.705a.28.28 0 0 1 .196.523 26.82 26.82 0 0 1-2.181.72.274.274 0 0 1-.219-.031zm5.513-2.254a.28.28 0 0 1 .013-.484c.657-.36 1.306-.75 1.928-1.162a.28.28 0 0 1 .306.467 27.2 27.2 0 0 1-1.968 1.187.281.281 0 0 1-.279-.008zm4.882-3.423a.28.28 0 0 1-.04-.448 26.089 26.089 0 0 0 1.624-1.562.277.277 0 0 1 .393-.008.28.28 0 0 1 .008.395 27.232 27.232 0 0 1-1.657 1.595.278.278 0 0 1-.328.028zm4.003-4.426-.018-.012a.281.281 0 0 1-.062-.39 26.29 26.29 0 0 0 1.099-1.66l.137-.226a.277.277 0 0 1 .381-.097l.003.001c.13.08.172.25.094.382l-.14.232a26.874 26.874 0 0 1-1.122 1.694.28.28 0 0 1-.372.076zm2.917-5.214a.28.28 0 0 1-.111-.346c.29-.69.554-1.401.786-2.117a.277.277 0 0 1 .35-.18c.146.05.226.206.179.352-.237.73-.507 1.457-.803 2.161a.277.277 0 0 1-.401.13zm1.694-5.733a.28.28 0 0 1-.128-.288c.132-.74.234-1.493.303-2.238a.278.278 0 1 1 .554.052c-.07.76-.174 1.529-.309 2.285a.28.28 0 0 1-.42.189zM120.609 53.321a.225.225 0 0 1-.047-.036c-.274-.262-.542-.53-.797-.797a.28.28 0 0 1 .008-.395.277.277 0 0 1 .393.008c.25.26.512.523.78.78a.28.28 0 0 1 .009.395.278.278 0 0 1-.346.045zM112.348 34.078a.28.28 0 0 1-.133-.238c-.002-.373.005-.753.019-1.13a.278.278 0 1 1 .556.022c-.015.369-.021.742-.019 1.106a.279.279 0 0 1-.423.24zM112.754 29.334a.28.28 0 0 1-.129-.288c.13-.74.294-1.485.486-2.215a.278.278 0 1 1 .539.143 27.2 27.2 0 0 0-.476 2.17.278.278 0 0 1-.42.19zm1.639-5.65a.283.283 0 0 1-.112-.346c.288-.697.608-1.39.952-2.058a.277.277 0 0 1 .375-.12c.139.072.191.24.12.378-.337.654-.65 1.332-.932 2.015a.278.278 0 0 1-.364.15c-.013-.005-.026-.012-.039-.02zm2.828-5.155-.015-.01a.282.282 0 0 1-.067-.389c.433-.615.897-1.219 1.38-1.796a.28.28 0 0 1 .426.36 26.777 26.777 0 0 0-1.351 1.76.279.279 0 0 1-.373.075zm3.888-4.402a.28.28 0 0 1-.042-.446 26.628 26.628 0 0 1 1.738-1.45.278.278 0 0 1 .39.053.28.28 0 0 1-.053.392c-.584.447-1.157.925-1.702 1.42a.276.276 0 0 1-.331.03zm4.75-3.443a.28.28 0 0 1 .008-.481 27.147 27.147 0 0 1 2.01-1.035.277.277 0 0 1 .369.137.28.28 0 0 1-.136.37c-.668.31-1.33.65-1.969 1.014a.276.276 0 0 1-.282-.005zm5.381-2.322a.28.28 0 0 1 .065-.506c.717-.22 1.453-.412 2.186-.57a.28.28 0 0 1 .117.547c-.717.154-1.437.342-2.141.558a.274.274 0 0 1-.227-.03zm5.755-1.084a.28.28 0 0 1 .125-.518c.749-.056 1.508-.08 2.257-.073a.278.278 0 0 1 .275.282.278.278 0 0 1-.281.276 26.323 26.323 0 0 0-2.21.072.264.264 0 0 1-.166-.039zm5.853.215a.28.28 0 0 1 .186-.514c.74.11 1.486.253 2.218.425.15.034.242.186.207.336a.278.278 0 0 1-.334.208 26.787 26.787 0 0 0-2.172-.417.282.282 0 0 1-.105-.038zm5.667 1.49a.28.28 0 0 1 .245-.5c.703.27 1.4.573 2.074.899.137.069.196.234.129.373a.277.277 0 0 1-.371.13c-.66-.32-1.344-.616-2.032-.88a.255.255 0 0 1-.045-.022zm7.016 4.015a.495.495 0 0 1-.029-.02 26.466 26.466 0 0 0-1.789-1.307.28.28 0 0 1-.078-.387.275.275 0 0 1 .386-.079c.625.417 1.239.866 1.827 1.335a.28.28 0 0 1 .045.393.276.276 0 0 1-.362.065zM158.975 16.29a.32.32 0 0 1-.065-.053 26.196 26.196 0 0 0-.743-.815.28.28 0 0 1 .009-.395.276.276 0 0 1 .393.009c.256.268.511.548.759.832a.28.28 0 0 1-.025.394.277.277 0 0 1-.328.029z",
    fill: "#91B3FA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M156.064 22.201a.322.322 0 0 0-.332-.167l-3.842.608a16.953 16.953 0 0 0-4.232-3.511l-.136-3.902a.318.318 0 0 0-.226-.295l-4.461-1.373a.318.318 0 0 0-.352.118l-2.288 3.156a16.877 16.877 0 0 0-5.464.528l-2.844-2.665a.318.318 0 0 0-.368-.048l-4.121 2.198a.321.321 0 0 0-.166.333l.605 3.86a16.995 16.995 0 0 0-3.495 4.25l-3.885.137a.318.318 0 0 0-.294.227l-1.367 4.481a.324.324 0 0 0 .117.354l3.143 2.298a17.061 17.061 0 0 0 .525 5.488l-2.651 2.856a.323.323 0 0 0-.049.37l2.188 4.14a.32.32 0 0 0 .332.166l3.841-.608a16.958 16.958 0 0 0 4.233 3.511l.135 3.902a.318.318 0 0 0 .226.296l4.461 1.372c.13.04.272-.007.352-.118l2.288-3.156a16.874 16.874 0 0 0 5.464-.528l2.844 2.664c.1.093.248.113.368.048l4.121-2.197a.321.321 0 0 0 .166-.333l-.605-3.86a17.015 17.015 0 0 0 3.495-4.25l3.885-.136a.318.318 0 0 0 .294-.227l1.366-4.481a.32.32 0 0 0-.117-.354l-3.142-2.298a17.09 17.09 0 0 0-.525-5.488l2.652-2.857a.32.32 0 0 0 .048-.37l-2.187-4.139z",
    fill: "#7D97F4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M136.691 37.833a4.59 4.59 0 0 1-2.179-4.141 4.558 4.558 0 0 1 1.495-3.168 4.517 4.517 0 0 1 3.287-1.179 4.522 4.522 0 0 1 3.154 1.502 4.562 4.562 0 0 1 1.172 3.301 4.562 4.562 0 0 1-1.495 3.168 4.518 4.518 0 0 1-3.287 1.179 4.51 4.51 0 0 1-2.147-.662zm4.315-7.108a3.7 3.7 0 0 0-1.755-.541 3.692 3.692 0 0 0-2.686.962 3.72 3.72 0 0 0-1.22 2.588c-.05.998.29 1.956.958 2.697a3.688 3.688 0 0 0 2.576 1.226 3.692 3.692 0 0 0 2.686-.962 3.72 3.72 0 0 0 1.22-2.588 3.725 3.725 0 0 0-.958-2.697c-.243-.27-.519-.5-.821-.685z",
    fill: "#91B3FA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M132.891 43.98c-4.436-2.725-6.663-8.22-5.071-13.44.294-.964.7-1.861 1.201-2.684 2.713-4.456 8.185-6.693 13.382-5.096l.278.09a11.612 11.612 0 0 1 2.007.889l-.407.732a10.895 10.895 0 0 0-2.123-.909l-.021-.006c-5.709-1.744-11.77 1.495-13.518 7.229-1.751 5.74 1.474 11.84 7.19 13.599 4.825 1.485 9.905-.593 12.425-4.732a10.953 10.953 0 0 0 1.277-8.289l.81-.201a11.754 11.754 0 0 1-.173 6.245c-.294.963-.701 1.86-1.201 2.683-2.713 4.455-8.185 6.693-13.382 5.095a11.56 11.56 0 0 1-2.674-1.205z",
    fill: "#91B3FA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m72.552 88.458-2.609 2.584c-3.703-.357-6.557-1.515-8.75-2.983 1.32-3.295 2.659-5.25 3.712-6.394 3.448 4.87 7.647 6.793 7.647 6.793z",
    fill: "url(#jml671aujQ)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m54.392 78.789 6.157-9.67c.404 5.454 2.239 9.555 4.356 12.545-1.053 1.145-2.393 3.1-3.712 6.395-5.47-3.664-6.801-9.27-6.801-9.27z",
    fill: "url(#w021454j8R)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M47.845 155.212c3.07.141 6.041.053 8.025-.05-1.806-1.291-5.968-4.101-9.45-5.22l-2.39-.143s-.81 1.237-1.1 4.069c.397.495 1.555 1.188 4.915 1.344z",
    fill: "url(#rffzpiq8aS)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m55.894 155.18-.025-.018c-1.984.102-4.955.191-8.025.049-3.36-.155-4.518-.847-4.914-1.344-.014.13-.027.261-.038.398-.05.621.41 1.167 1.029 1.213 2.514.192 8.747.623 11.753.465.396-.02.544-.532.22-.763z",
    fill: "url(#8tp0lv6ofT)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M25.889 154.386c-.225-1.448-.585-3.54-.864-4.075-.437-.839-1.933 0-1.933 0s-1.05.492-1.534 1.311c-.308.523-1.16 2.009-1.737 3.019a.68.68 0 0 0-.09.359l5.99.211c.146-.235.215-.523.168-.825z",
    fill: "url(#43za2yovfU)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M19.731 155.001c.01.344.282.655.664.666l4.268.118c.45.012.84-.223 1.059-.574l-5.99-.21z",
    fill: "url(#fb37050usV)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M26.345 145.5c-.051.173-.825 3.942-1.164 5.596a.942.942 0 0 1-.968.755 11.212 11.212 0 0 1-.858-.076 1.138 1.138 0 0 1-.987-1.087c-.055-1.449-.082-4.231.447-5.309.732-1.486 3.53.121 3.53.121z",
    fill: "url(#8475yzxk0W)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M43.559 146.579c.331-.011-.133 1.722.37 3.424.113.384.399.686.798.69.258.004.564-.002.875-.027a.964.964 0 0 0 .887-.871l.408-4.415-3.338 1.199z",
    fill: "url(#9g4tsu6wkX)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M52.843 99.64c-.148.724-5.377 31.362-5.694 47.216a.539.539 0 0 1-.462.525c-.664.093-1.957.213-3.21-.021a.38.38 0 0 1-.312-.349c-.183-2.954-1.653-27.934.147-39.692 0 0-14.868 31.433-17.122 40.101a.454.454 0 0 1-.465.341c-.637-.034-1.96-.149-3.012-.538a.792.792 0 0 1-.497-.929c1.259-5.187 10.084-40.924 16.076-48.798l14.551 2.144z",
    fill: "url(#o2rjxtg5jY)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M43.312 107.514a.196.196 0 0 1-.14-.333l1.991-2.045a.195.195 0 0 1 .276-.003.197.197 0 0 1 .003.278l-1.991 2.045a.196.196 0 0 1-.14.058z",
    fill: "url(#h7ozjecssZ)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M61.343 61.282c-3.82-1.006-10.864-2.58-16.473-2.244a2.544 2.544 0 0 0-2.393 2.394c-.847 15.004-2.005 28.317-4.185 36.063 4.9 1.948 9.759 2.852 14.551 2.144 3.591-7.725 6.73-16.643 9.412-26.771 0 0 1.574-8.078.046-10.771-.238-.42-.551-.709-.958-.816z",
    fill: "url(#hxdeam3uaaa)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M52.156 50.771s-.965 5.78-1.252 8.452c-.047.435.18.845.566 1.045 1.054.545 3.304 1.423 5.756.618a.977.977 0 0 0 .66-.952l-.168-7.715-5.563-1.448z",
    fill: "url(#i5jbe9chwab)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M58.446 44.367s1.86 4.294 1.985 6.548c.125 2.254.609 3.716-1.985 4.17-2.595.453-4.78-.846-5.964-3.09 0 0-1.855-3.458-1.439-4.876.416-1.416 7.403-2.752 7.403-2.752z",
    fill: "url(#r4ta31sk5ac)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M53.37 50.382h.327s-1.351-2.784-.163-3.273c1.187-.49 5.89-1.453 6.905-3.129.978-1.615.105-3.703-1.2-4.287a.175.175 0 0 0-.222.083l-.108.205a.176.176 0 0 1-.325-.033c-.042-.145-.237-.177-.316-.048-.31.5-1.152 1.316-3.407 1.734-3.201.593-5.317 1.895-5.37 4.117a.176.176 0 0 1-.272.145c-.236-.145-.615-.213-1.12.215-.878.742-.519 2.667 1.408 4.252.091.075.091.219-.008.283-.35.228-.87.772.479 1.497 1.38.741 2.196.66 2.505.58a.177.177 0 0 0 .133-.183l-.122-1.97a.177.177 0 0 1 .176-.187h.7v-.002z",
    fill: "url(#hfm11kgg4ad)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M53.45 50.793s-.71-2.742-1.934-1.974c-1.224.77.635 3.073 1.62 3.176l.314-1.202z",
    fill: "url(#3bf8p6f3nae)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m13.726 95.417-2.513.638c-4.312 1.095-7.212 4.35-6.477 7.271l.874 3.472c.735 2.921 4.827 4.402 9.14 3.306l2.512-.638c.167-.042.332-.088.497-.137l73.69-22.148-1.903-7.564-75.318 15.685a8.63 8.63 0 0 0-.502.115zm1.082 3.465c3.247-.824 6.275.078 6.762 2.016.488 1.938-1.749 4.177-4.996 5.002-3.246.824-6.274-.078-6.761-2.016-.488-1.938 1.749-4.177 4.995-5.002z",
    fill: "url(#bkcetxui6af)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M114.047 69.337 99.465 73.04a3.458 3.458 0 0 0-2.322 1.984l-2.181 5.06a3.476 3.476 0 0 0 1.032 4.102l4.314 3.411c.841.665 1.942.9 2.981.638l14.582-3.702c2.199-.559 4.068 1.747 3.029 3.773-2.484 4.848-7.043 8.68-12.844 10.154-10.487 2.663-19.768-3.718-22.318-13.851-2.55-10.132 2.597-20.177 13.084-22.84 5.802-1.473 11.627-.275 16.106 2.803 1.872 1.287 1.319 4.208-.881 4.766z",
    fill: "url(#2fpyho06rag)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M114.394 70.718 99.812 74.42a3.456 3.456 0 0 0-2.321 1.983l-2.182 5.06a3.476 3.476 0 0 0 1.033 4.103l4.313 3.41c.842.666 1.943.901 2.981.638l14.582-3.703c2.2-.558 4.068 1.748 3.03 3.774-2.485 4.847-7.043 8.68-12.845 10.153-10.487 2.663-19.767-3.718-22.317-13.851-2.55-10.132 2.598-20.177 13.084-22.84 5.802-1.473 11.626-.276 16.105 2.803 1.873 1.289 1.319 4.21-.881 4.768z",
    fill: "url(#s7oyrzbpdah)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m14.004 96.518-2.513.638c-4.313 1.095-7.213 4.35-6.478 7.271l.874 3.472c.735 2.921 4.827 4.401 9.14 3.306l2.513-.638c.166-.042.331-.088.496-.138l73.69-22.147-1.903-7.565-75.317 15.686c-.169.034-.336.072-.502.115zm1.082 3.466c3.246-.825 6.274.078 6.761 2.016.488 1.938-1.749 4.176-4.995 5.001-3.247.824-6.275-.078-6.762-2.016-.488-1.938 1.75-4.177 4.996-5.001z",
    fill: "url(#j6qmc4yo1ai)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M32.592 81.263c-1.888 5.323-.825 11.03-.825 11.03l-2.49.666s-3.216-3.843-2.48-12.37c2.298-.352 4.45.19 5.795.674z",
    fill: "url(#bdt3n2wmkaj)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M26.796 80.59c.082-.96.213-1.974.406-3.053C28.883 68.134 40.886 60.9 43.71 59.315a.386.386 0 0 1 .573.354l-.401 12.783c-6.685.903-9.848 4.744-11.292 8.81-1.344-.484-3.496-1.025-5.794-.672z",
    fill: "url(#43vx4hhe1ak)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M77.802 93.148c.466-.129.845-.463 1.043-.906.382-.86.812-2.239-.106-2.658-1.37-.625-3.86 1.938-3.86 1.938l-1.216 1.98-1.112.543c1.019.282 2.984-.187 5.25-.897z",
    fill: "url(#ezajj3bq0al)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M31.603 91.043h3.078s-2.497 1.504-2.58 3.086c-.084 1.582.99 4.86 1.494 5.75.55.976-6.97-1.452-4.316-8.836h2.324z",
    fill: "url(#8y2lfs2a5am)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M183.62 242.579v2.65c0 .678-.347 1.238-.806 1.299l-41.161 3.747a2.962 2.962 0 0 1-1.154-.069l-28.679-5.43c-.305-.079-.529-.48-.529-.945v-2.8l30.429-3.788 3.917-1.862 3.895.564 2.3-.442 5.256 1.536 26.532 5.54z",
    fill: "url(#888gwhvzdan)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M183.621 242.58v2.649c0 .679-.347 1.239-.806 1.3l-41.16 3.747a2.952 2.952 0 0 1-.914-.019v-14.275l4.898-.602 3.894.564 2.299-.442 5.257 1.536 26.532 5.542z",
    fill: "url(#f3zwgnf75ao)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m151.832 235.501-40.54 5.406 29.241 5.532c.361.092.726.114 1.088.064l42-3.923-31.789-7.079z",
    fill: "url(#y7348oye9ap)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M166.694 240.384c0 1.94-6.076 3.447-14.464 3.838-2.117.098-4.38.125-6.729.071-11.544-.268-20.819-2.425-20.819-4.812 0-.054.006-.172.016-.172h-.016l.048-.115a.653.653 0 0 1 .043-.111l2.662-6.991 3.215-8.436 4.503-11.823 3.446-9.05 4.286-11.253c.537-1.409 1.53-2.284 2.605-2.284.146 0 .288.015.43.047.907.199 1.717 1.019 2.182 2.241l4.322 11.332 3.453 9.169 4.555 12.06v.003l3.27 8.665v.002l.052.006 2.724 7.042c.118.186.216.378.216.571z",
    fill: "url(#ue3mxfnybaq)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M163.756 232.769c-2.628.882-6.83 1.518-11.86 1.754a97.197 97.197 0 0 1-6.406.084c-7.756-.148-14.481-1.151-18.06-2.514l3.218-8.437c3.766.851 9.014 1.424 14.848 1.512 1.886.029 3.725.005 5.475-.066 3.684-.146 6.932-.502 9.491-1.006l3.243 8.665v.002l.051.006zM155.917 212.033a84.085 84.085 0 0 1-6.551.433 98.352 98.352 0 0 1-3.864.036c-3.775-.036-7.307-.279-10.349-.669l3.446-9.05c2.157.171 4.48.268 6.903.282.856.006 1.7 0 2.527-.017a92.547 92.547 0 0 0 4.396-.184l3.492 9.169z",
    fill: "#fff"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M120.534 229.156v1.637c0 .419-.214.765-.498.803l-25.43 2.315a1.82 1.82 0 0 1-.712-.043l-17.719-3.354c-.188-.049-.326-.297-.326-.584v-1.73l18.799-2.34 2.42-1.151 2.406.349 1.421-.274 3.248.95 16.391 3.422z",
    fill: "url(#c7uiu3zn7ar)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M120.534 229.157v1.637c0 .419-.214.765-.498.803l-25.428 2.315c-.189.026-.424.02-.565-.012v-8.819l3.026-.372 2.406.348 1.42-.273 3.248.949 16.391 3.424z",
    fill: "url(#7qie93k2las)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m100.894 224.784-25.045 3.339 18.065 3.418c.223.057.448.071.672.04l25.948-2.424-19.64-4.373z",
    fill: "url(#hhvxjonc3at)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M110.076 227.8c0 1.198-3.754 2.129-8.936 2.371-1.308.06-2.707.077-4.157.044-7.133-.166-12.863-1.498-12.863-2.973 0-.034.004-.106.01-.106h-.01l.03-.071a.386.386 0 0 1 .026-.069l1.645-4.319 1.987-5.212 2.781-7.304 2.13-5.591 2.648-6.953c.33-.87.945-1.411 1.608-1.411.091 0 .179.009.267.029.56.124 1.06.63 1.347 1.385l2.671 7.001 2.133 5.665 2.814 7.45v.002l2.02 5.353v.002l.032.003 1.683 4.351c.073.115.134.233.134.353z",
    fill: "url(#nuf3yc5ekau)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M108.26 223.095c-1.624.546-4.22.938-7.327 1.084a60.24 60.24 0 0 1-3.958.052c-4.792-.091-8.946-.711-11.158-1.553l1.989-5.213c2.326.526 5.569.88 9.173.935 1.165.018 2.301.003 3.383-.041 2.275-.091 4.282-.31 5.863-.622l2.004 5.353v.002l.031.003zM103.417 210.285a51.988 51.988 0 0 1-4.047.267c-.775.023-1.573.031-2.388.023-2.332-.023-4.514-.173-6.393-.414l2.129-5.591a58.547 58.547 0 0 0 5.826.163 56.019 56.019 0 0 0 2.715-.113l2.158 5.665z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mtpq1n1gxa",
    x1: 264.796,
    y1: 283.074,
    x2: 81.022,
    y2: 85.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xvop7nf2mb",
    x1: 103.939,
    y1: 198.362,
    x2: 159.199,
    y2: 33.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zj5wxd2vcc",
    x1: 134.041,
    y1: 116.599,
    x2: 122.567,
    y2: 241.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crersu8ead",
    x1: 157.257,
    y1: 75.757,
    x2: 169.88,
    y2: 75.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uerv5snm3e",
    x1: 209.166,
    y1: 7.642,
    x2: 196.458,
    y2: 34.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y2vc1ey47f",
    x1: 201.385,
    y1: 26.046,
    x2: 177.323,
    y2: 58.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sklpwxdhmg",
    x1: 204.217,
    y1: 5.327,
    x2: 191.51,
    y2: 32.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s0qkhzjduh",
    x1: 213.912,
    y1: 9.864,
    x2: 201.205,
    y2: 37.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fzci3la75i",
    x1: 201.165,
    y1: 25.918,
    x2: 180.808,
    y2: 16.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fe6kmw7exj",
    x1: 220.921,
    y1: 35.322,
    x2: 200.564,
    y2: 25.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grpt5jvtrk",
    x1: 175.285,
    y1: 137.526,
    x2: 200.514,
    y2: 137.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tsxtpc93dl",
    x1: 203.696,
    y1: 151.959,
    x2: 214.772,
    y2: 181.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wkud142c4m",
    x1: 227.271,
    y1: 225.567,
    x2: 214.331,
    y2: 225.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hojbwgth9n",
    x1: 220.801,
    y1: 199.223,
    x2: 220.801,
    y2: 226.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8n9jprxnco",
    x1: 250,
    y1: 225.599,
    x2: 243.941,
    y2: 225.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap5ezu0pbp",
    x1: 249.197,
    y1: 205.56,
    x2: 246.449,
    y2: 234.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2mi712asq",
    x1: 247.437,
    y1: 221.404,
    x2: 243.506,
    y2: 221.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "te2isqaecr",
    x1: 226.613,
    y1: 221.146,
    x2: 223.337,
    y2: 221.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "70bt5dwa5s",
    x1: 237.279,
    y1: 181.41,
    x2: 264.793,
    y2: 93.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ucmprtgowt",
    x1: 225.855,
    y1: 180.298,
    x2: 230.256,
    y2: 155.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "32vza1ss0u",
    x1: 209.682,
    y1: 84.047,
    x2: 155.507,
    y2: 131.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n9y4j76uvv",
    x1: 206,
    y1: 139.454,
    x2: 243.808,
    y2: 87.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lruo0ff0tw",
    x1: 204.099,
    y1: 148.724,
    x2: 192.252,
    y2: 180.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c91dcxresx",
    x1: 232.335,
    y1: 144.74,
    x2: 208.407,
    y2: 171.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ybnw1sjzry",
    x1: 234.052,
    y1: 146.29,
    x2: 210.124,
    y2: 172.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0agd09oocz",
    x1: 210.012,
    y1: 126.229,
    x2: 219.252,
    y2: 120.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7no33qbarA",
    x1: 224.11,
    y1: 114.629,
    x2: 212.161,
    y2: 124.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0sz3zqwihB",
    x1: 212.433,
    y1: 128.335,
    x2: 220.747,
    y2: 123.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pjqwxcd3nC",
    x1: 199.96,
    y1: 208.871,
    x2: 204.057,
    y2: 178.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i4zj4lnpyD",
    x1: 204.651,
    y1: 164.688,
    x2: 202.83,
    y2: 176.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jseehawu7E",
    x1: 200.246,
    y1: 190.159,
    x2: 198.336,
    y2: 199.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0faus1243F",
    x1: 43.476,
    y1: 50.671,
    x2: 44.309,
    y2: 50.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "80kjjyuosG",
    x1: 43.551,
    y1: 27.19,
    x2: 105.682,
    y2: 27.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "36upx3dkxH",
    x1: 108.692,
    y1: 20.726,
    x2: 110.459,
    y2: 20.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "67orz2kkhI",
    x1: 120.447,
    y1: 48.703,
    x2: 121.206,
    y2: 48.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bca9a8vdeJ",
    x1: 57.486,
    y1: 70.498,
    x2: 120.702,
    y2: 70.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3l5whc3g4K",
    x1: 52.977,
    y1: 74.079,
    x2: 54.69,
    y2: 74.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8im3agfyoL",
    x1: 53.077,
    y1: 47.758,
    x2: 111.727,
    y2: 47.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h39mjaw0qM",
    x1: 119.787,
    y1: 58.021,
    x2: 121.447,
    y2: 58.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDD0FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "okkf6itdeN",
    x1: 124.701,
    y1: 68.669,
    x2: 143.741,
    y2: 68.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDD0FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qv3fifnjwO",
    x1: 110.314,
    y1: 65.3,
    x2: 111.509,
    y2: 65.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y8rmy50p2P",
    x1: 112.156,
    y1: 75.095,
    x2: 139.612,
    y2: 75.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jml671aujQ",
    x1: 69.097,
    y1: 82.337,
    x2: 55.715,
    y2: 117.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w021454j8R",
    x1: 53.494,
    y1: 38.188,
    x2: 58.046,
    y2: 69.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rffzpiq8aS",
    x1: 42.889,
    y1: 152.542,
    x2: 56.072,
    y2: 152.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8tp0lv6ofT",
    x1: 49.48,
    y1: 125.703,
    x2: 49.48,
    y2: 153.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "43za2yovfU",
    x1: 19.731,
    y1: 152.575,
    x2: 25.904,
    y2: 152.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb37050usV",
    x1: 20.549,
    y1: 132.16,
    x2: 23.349,
    y2: 161.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8475yzxk0W",
    x1: 22.341,
    y1: 148.3,
    x2: 26.346,
    y2: 148.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9g4tsu6wkX",
    x1: 43.558,
    y1: 148.037,
    x2: 46.896,
    y2: 148.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o2rjxtg5jY",
    x1: 59.108,
    y1: 66.065,
    x2: 33.848,
    y2: 146.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h7ozjecssZ",
    x1: 51.859,
    y1: 96.488,
    x2: 38.121,
    y2: 114.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hxdeam3uaaa",
    x1: 77.908,
    y1: 59.525,
    x2: 37.48,
    y2: 86.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i5jbe9chwab",
    x1: 48.528,
    y1: 63.003,
    x2: 63.345,
    y2: 46.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r4ta31sk5ac",
    x1: 50.372,
    y1: 54.652,
    x2: 39.699,
    y2: 62.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hfm11kgg4ad",
    x1: 51.363,
    y1: 41.693,
    x2: 61.049,
    y2: 54.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3bf8p6f3nae",
    x1: 57.517,
    y1: 46.415,
    x2: 46.844,
    y2: 54.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bkcetxui6af",
    x1: 4.621,
    y1: 95.04,
    x2: 91.449,
    y2: 95.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2fpyho06rag",
    x1: 85.094,
    y1: 80.102,
    x2: 121.195,
    y2: 80.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s7oyrzbpdah",
    x1: -1830.73,
    y1: 872.564,
    x2: -1749.17,
    y2: 839.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j6qmc4yo1ai",
    x1: -1801.43,
    y1: 793.301,
    x2: -1702.23,
    y2: 749.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bdt3n2wmkaj",
    x1: 31.083,
    y1: 83.827,
    x2: 16.055,
    y2: 105.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "43vx4hhe1ak",
    x1: 70.463,
    y1: 48.394,
    x2: 30.035,
    y2: 75.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezajj3bq0al",
    x1: 78.435,
    y1: 85.877,
    x2: 65.053,
    y2: 121.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8y2lfs2a5am",
    x1: 36.806,
    y1: 87.752,
    x2: 21.604,
    y2: 109.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "888gwhvzdan",
    x1: 146.98,
    y1: 245.244,
    x2: 160.027,
    y2: 190.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f3zwgnf75ao",
    x1: 162.233,
    y1: 240.263,
    x2: 169.518,
    y2: 183.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y7348oye9ap",
    x1: 153.879,
    y1: 195.199,
    x2: 149.63,
    y2: 225.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ue3mxfnybaq",
    x1: 251.026,
    y1: -27,
    x2: 229.803,
    y2: 26.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c7uiu3zn7ar",
    x1: 97.897,
    y1: 230.803,
    x2: 105.958,
    y2: 197.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7qie93k2las",
    x1: 107.321,
    y1: 227.725,
    x2: 111.821,
    y2: 192.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hhvxjonc3at",
    x1: 102.159,
    y1: 199.885,
    x2: 99.534,
    y2: 218.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nuf3yc5ekau",
    x1: 162.177,
    y1: 62.608,
    x2: 149.065,
    y2: 95.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationMaintenance);
export default __webpack_public_path__ + "static/media/IllustrationMaintenance.75bf7ff1.svg";
export { ForwardRef as ReactComponent };